'use client';

import { useRouter, useSearchParams } from 'next/navigation';
import {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react';

const SearchContext = createContext({
  isEmptySearch: false,
  setIsAuthorEmpty: (value: boolean) => {},
  setIsArticleEmpty: (value: boolean) => {},
});

export const useSearchResult = () => useContext(SearchContext);

export const SearchProvider = ({ children }: PropsWithChildren) => {
  const router = useRouter();
  const searchParams = useSearchParams().get('q');
  const [isAuthorEmpty, setIsAuthorEmpty] = useState(false);
  const [isArticleEmpty, setIsArticleEmpty] = useState(false);

  useEffect(() => {
    if (!searchParams) {
      router.back();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SearchContext.Provider
      value={{
        isEmptySearch: isAuthorEmpty && isArticleEmpty,
        setIsAuthorEmpty,
        setIsArticleEmpty,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};
